import { configureStore } from "@reduxjs/toolkit";
import { uiReducer } from "./ui/ui.slice";
import {
  baseApi,
  connectBaseApi,
  networkReducer,
  createRtkqLoadingMiddleware,
  createGlobalErrorMiddleware,
} from "@racoon/api";

const rtkqLoadingMiddleware = createRtkqLoadingMiddleware([baseApi, connectBaseApi]);
const globalErrorMiddleware = createGlobalErrorMiddleware([baseApi, connectBaseApi]);

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    [connectBaseApi.reducerPath]: connectBaseApi.reducer,
    network: networkReducer,
    ui: uiReducer,
  },
  middleware: (gDM) =>
    gDM().concat(
      baseApi.middleware,
      connectBaseApi.middleware,
      rtkqLoadingMiddleware,
      globalErrorMiddleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
